export const AUTH_USER = "AUTH_USER";
export const LOGOUT = "LOGOUT";
export const USER_FAILED = "USER_FAILED";
